const initialState = {
  auth: {
    isAuthenticated: false,
    user: null
  },
}

export default name => initialState[name] || {};